module.exports = __webpack_public_path__ + "img/img_baby_admin_2_ko.9c0b6225.png";